import { createSlice } from '@reduxjs/toolkit';
import { findServiceProduct } from './api';
import { initialState } from './api/interface';

const serviceProductSlice = createSlice({
  name: 'serviceProduct',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findServiceProduct.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findServiceProduct.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.total;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(findServiceProduct.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  serviceProductSlice.actions;
export default serviceProductSlice.reducer;
